import { render, staticRenderFns } from "./ProductPayments.vue?vue&type=template&id=65d5bbe7&"
import script from "./ProductPayments.vue?vue&type=script&lang=js&"
export * from "./ProductPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports